export var fetchTenantCulture = async function fetchTenantCulture(host, tenant) {
  try {
    // we need to make sure the host ends with slash - so that URL() doesn't remove any part from it!
    var hostWithSlash = host.endsWith('/') ? host : host + "/";
    var url = new URL("tenants/" + tenant + "/culture", hostWithSlash).toString();
    var response = await fetch(url);

    if (response.status !== 200) {
      console.error("Error in API response - status: " + response.status + ", message: " + (await response.text()));
      return undefined;
    }

    try {
      var data = await response.json();
      return data;
    } catch (error) {
      var errorWithMessage = error;
      console.error("Could not parse TenantCulture from API: " + errorWithMessage.message);
      return undefined;
    }
  } catch (error) {
    var _errorWithMessage = error;
    console.error("Could not fetch TenantCulture from API: " + _errorWithMessage.message);
    return undefined;
  }
};